export const LAMBDA_EXCLUDED_ENDPOINTS = ['startInstance', 'checkInstance', 'stopInstance', 'getInstanceStatus'];
